import React, { useState, useEffect } from 'react';

import GenericInputContainer from '../shared/GenericInputContainer';
import DisplayItem from './DisplayItem';
import EditItem from './EditItem';

const ItemInputContainer = ({
    iconName,
    initialValue: onPageLoadInitialItem,
    syncChanges,
    getSuggestions,
    isEditing,
    setIsEditing,
    isHovered,
    isCreationPermitted,
}) => {
    const [item, setItem] = useState(onPageLoadInitialItem);
    const [initialItem, setInitialItem] = useState(onPageLoadInitialItem);

    useEffect(() => {
        setItem(onPageLoadInitialItem);
        setInitialItem(onPageLoadInitialItem);
    }, [onPageLoadInitialItem]);

    const isFieldNull = !item || !item.name.length;

    const valueHasntChanged = () => {
        return item?.id === initialItem?.id;
    };

    const handleSave = async () => {
        const response = await syncChanges(item);
        if (response.success) {
            setItem(response.value);
            setInitialItem(response.value);
        }
        return response;
    };

    const handleCancel = () => {
        setItem(initialItem);
    };

    return (
        <GenericInputContainer {...{ isEditing, setIsEditing, isHovered, isFieldNull, handleSave, handleCancel, valueHasntChanged }}>
            <DisplayItem {...{ item }} />
            <EditItem {...{ iconName, value: item, setValue: setItem, getSuggestions, isCreationPermitted, isClearable: true }} />
        </GenericInputContainer>
    );
};

export default ItemInputContainer;
